const __RELATIVE_SOURCE_FILE__ /* __INJECTED__ */ = 'libs/common_web/src/components/TransitionOnCondition/TransitionOnCondition.tsx';
import { css, cx } from '@emotion/css';
import { useEffect, useState } from 'react';

const transitionOnCondition = css`
    overflow: hidden;

    &.closed {
        display: none;
    }
`;

export const TransitionOnCondition = (props: { children: any; val: boolean }) => {
    return <div className={cx(transitionOnCondition, { opened: props.val, closed: !props.val })}>{props.children}</div>;
};
